import { toggleButtonClasses, toggleButtonGroupClasses } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

export const CARD_SX = { border: 1, borderColor: "divider", borderRadius: 2, p: 2, display: "flex", flexDirection: "column", gap: 1.5 } satisfies SxProps<Theme>
export const HEADER_SX = { display: "flex", alignItems: "center", gap: 1 } satisfies SxProps<Theme>
export const TITLE_SX = { fontWeight: 600 } satisfies SxProps<Theme>
export const BODY_SX = { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 } satisfies SxProps<Theme>
// The basis is the wrap threshold: below it plus the control, the control drops under the text.
export const TEXT_SX = {
  flex: (theme) => `1 1 ${theme.spacing(30)}`,
  minWidth: (theme) => theme.spacing(30),
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
} satisfies SxProps<Theme>
export const MUTED_SX = { color: "text.secondary" } satisfies SxProps<Theme>
// Two separate pills, not MUI's joined segmented bar: the group's first/middle/last rules square the inner
// corners and overlap the borders, so each grouped button is reset here.
export const CONTROL_SX = {
  flexShrink: 0,
  gap: 1,
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    m: 0,
    border: 1,
    borderColor: "divider",
    borderRadius: 999,
    px: 2,
    py: 0.5,
    textTransform: "none",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  [`& .${toggleButtonGroupClasses.grouped}.${toggleButtonClasses.selected}`]: {
    bgcolor: "var(--app-primary-filled)",
    color: "var(--app-text-on-dark-bg)",
    borderColor: "var(--app-primary-filled)",
    "&:hover": { bgcolor: "var(--app-primary-filled)" },
  },
} satisfies SxProps<Theme>
